var map = {
	"./dreamroom.jpg": 42,
	"./florida.jpg": 43,
	"./furniture.png": 44,
	"./hallowkitty.jpg": 45,
	"./musicapp.png": 46,
	"./orca.jpg": 47,
	"./rzd.jpg": 48,
	"./wobbly.jpg": 49,
	"./woodworking.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;